import { gql } from '@apollo/client';
import { addTypePolicies } from 'src/lib/graphql/cache';
import useGQLPaginatedQuery from 'src/lib/graphql/hooks/useGQLPaginatedQuery';
import paginatedListFieldPolicy from 'src/lib/graphql/utils/paginatedListFieldPolicy';
import { EP_ANCESTORS_DETAILS_FIELDS } from '../common/fragments/ancestorsDetails';
import { EP_QUESTION_DATA_FIELDS } from './getQuestionDetails';
const QUESTION_SEARCH_QUERY = gql `
  query EP_QuestionSearch(
    $query: String!
    $answered: Boolean
    $read: Boolean
    $bookmarked: Boolean
    $includeDuplicates: Boolean,
    $qpStartDate: DateTimeISO
    $qpEndDate: DateTimeISO
    $sortBy: Int
    $pagination: PaginationOptions
    $ancestorID: ID
    $withAncestorsDetails: Boolean = false
  ) {
    ep_questionSearch(
      query: $query
      answered: $answered
      read: $read
      bookmarked: $bookmarked
      includeDuplicates: $includeDuplicates
      qpStartDate: $qpStartDate
      qpEndDate: $qpEndDate
      pagination: $pagination
      ancestorID: $ancestorID
      sortBy: $sortBy
    ) {
      totalCount
      list {
        id
        type
        data {
          ...EPQuestionDataFields
        }
        userData {
          read
          bookmarked
        }
        attributes {
          answered
        }
        questionPaper {
          data {
            dateNL
            label
          }
        }
        duplicates {
          questionPaper {
            data {
              dateNL
              label
            }
          }
        }
        ancestorsDetails @include(if: $withAncestorsDetails) {
          ...EPAncestorsDetailsFields
        }
      }
    }
  }

  ${EP_QUESTION_DATA_FIELDS}
  ${EP_ANCESTORS_DETAILS_FIELDS}
`;
export function useEPQuestionSearchQuery(options) {
    return useGQLPaginatedQuery(QUESTION_SEARCH_QUERY, 'ep_questionSearch', options);
}
addTypePolicies({
    Query: {
        fields: {
            ep_questionSearch: paginatedListFieldPolicy([
                'query',
                'answered',
                'read',
                'bookmarked',
                'includeDuplicates',
                'qpStartDate',
                'qpEndDate',
                'sortBy',
                'ancestorID',
            ]),
        },
    },
});
